import { useCallback, useEffect, useState } from 'react';

export const UpdateStatus = {
    checking: 'checking',
    current: 'current',
    available: 'available',
  }

const reloadPage = () => window.location.reload(true);

const currentVersionTag = import.meta.env.VITE_APP_VERSION_TAG;

function useUpdateCheck ({
  interval,
  type,
  ignoreServerCache=true,
}) {
  const [status, setStatus] = useState(UpdateStatus.checking);

  const checkUpdate = useCallback(() => {
    if (!currentVersionTag) {
      setStatus(UpdateStatus.current);
      return;
    }

    setStatus(UpdateStatus.checking);

    let requestStr = `/version-tracker-${currentVersionTag}.txt`;

    if (ignoreServerCache) {
      requestStr += `?v=${Date.now()}`;
    }

    fetch(requestStr)
      .then(res => {
        if(!res.ok){
          setStatus(UpdateStatus.available)
          return
        }
        else return res.text()
      })
      .then(response => {
        if(response === 'this is the version tracker'){
          setStatus(UpdateStatus.current)
        }else{
          setStatus(UpdateStatus.available)
        }
      })
      .catch(() => null)
  }, [ignoreServerCache]);

  useEffect(() => {
    if (type !== 'manual') {
      checkUpdate();
    }
  }, [checkUpdate, type]);

  useEffect(() => {
    if (status !== UpdateStatus.current) {
      return;
    }

    if (type === 'interval') {
      const timeoutId = window.setTimeout(
        () => checkUpdate(),
        interval || 10000
      );

      return () => {
        clearTimeout(timeoutId);
      };
    }
  }, [type, interval, status, checkUpdate]);

  return { status, reloadPage, checkUpdate };
};
export default useUpdateCheck